<svg xmlns="http://www.w3.org/2000/svg" width="72" height="44" viewBox="0 0 72 44">
    <g transform="translate(-580 -445)">
        <g transform="translate(580 445)" fill="none" stroke="#000" stroke-width="1">
            <rect width="72" height="44" rx="8" stroke="none"/>
            <rect x="0.5" y="0.5" width="71" height="43" rx="7.5" fill="none"/>
        </g>
        <text transform="translate(588 471)" font-size="12" font-family="sans-serif"
              font-weight="800">
            <tspan x="0" y="0">Rechnung</tspan>
        </text>
    </g>
</svg>
